<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<fieldset class="form__group">
			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

			<legend>The Company</legend>

			<div class="form__group">
				<input id="company" name="companyName" class="form__control" v-model="formData.companyName"
				       placeholder="Enter company's name here..." v-validate required />
				<label for="company" class="form__label">Client company name</label>
				<div class="form__validation">{{ errors.first('companyName') }}</div>
			</div>

			<div class="form__group">
				<input id="location" name="location" class="form__control" v-model="formData.location"
				       placeholder="Enter the location of activities here..." v-validate required />
				<label for="location" class="form__label">Location of Activities</label>
				<div class="form__validation">{{ errors.first('location') }}</div>
			</div>

			<div class="form__group">
				<textarea id="activity" name="activity" class="form__control" v-model="formData.activity"
				          placeholder="Enter company bio here..." v-validate required></textarea>
				<label for="activity" class="form__label">Company Bio</label>
				<div class="form__validation">{{ errors.first('activity') }}</div>
			</div>

            <div class="form__group">
                <input id="tombstone" name="tombstone" class="form__control" v-model="formData.tombstone"
                       placeholder="Enter tombstone..." v-validate maxlength="65" />
                <label for="tombstone" class="form__label">Tombstone Company Description</label>
                <div class="form__validation">{{ errors.first('tombstone') }}</div>
                <p class="form__character-count"><small>{{ tombstoneSize }} / 65 characters</small></p>
            </div>

			<div class="form__group">
				<FormControlDatepicker v-model="formData.completedAt" label="Deal Completed Date"></FormControlDatepicker>
			</div>

			<FormControlDealType v-model="formData.dealType" name="dealType" v-validate="'required'">
			</FormControlDealType>

			<div class="form__group" v-if="formData.dealType === 1 || formData.dealType === 2 || formData.dealType === 5">
				<input id="counterpart" name="counterpart company" class="form__control"
				       v-model="formData.counterpartCompany"
				       placeholder="Enter counterpart company's name here..." v-validate required />
				<label for="counterpart" class="form__label">Counterpart company</label>
				<div class="form__validation">{{ errors.first('counterpart company') }}</div>
			</div>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import FormControlDatepicker from '../../Form/Control/FormControlDatepicker';
	import FormControlDealType from '../../Form/Control/FormControlDealType';
	import MADDFormStep from './MADDFormStep';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlCountry from '../../Form/Control/FormControlCountry';

	export default {
		name: 'MADDFormStep2',
		mixins: [MADDFormStep],
		components: {
			FormControlCountry,
			ValidationAlert,
			FormControlDealType,
			FormControlDatepicker
		},
        computed: {
            tombstoneSize() {
                return this.formData.tombstone ? this.formData.tombstone.length : 0;
            },
        },
		data() {
			return {
				formData: {
					companyName: null,
					location: null,
					activity: null,
					dealType: null,
					counterpartCompany: null,
					completedAt: null,
                    tombstone: null,
				}
			}
		},
	}
</script>
